import { useState, useCallback, type ReactNode } from 'react';
import ConfirmDialog from '@/components/ConfirmDialog';
import { useI18nText } from '@/lib/utils/i18nText';

interface DeletePopoverProps {
  /** 다이얼로그를 열 트리거 요소 */
  children: ReactNode;
  /** 본문 확인 메시지 */
  description?: string;
  /** 삭제 실행 함수. throw 시 에러 인라인 표시. 성공 시 자동 닫힘 */
  onConfirm: () => Promise<void>;
  disabled?: boolean;
}

export default function DeletePopover({
  children,
  description,
  onConfirm,
  disabled,
}: DeletePopoverProps) {
  const { t } = useI18nText();
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled) setOpen(true);
  }, [disabled]);

  return (
    <>
      <span className="inline-flex" onClick={handleOpen}>
        {children}
      </span>
      <ConfirmDialog
        open={open}
        onOpenChange={setOpen}
        title={t('Confirm Delete', '삭제 확인')}
        destructive
        onConfirm={onConfirm}
      >
        <p>{description ?? t('Are you sure you want to delete this?', '삭제하시겠습니까?')}</p>
        <p className="mt-2 text-xs text-ggc-red">
          <i className="fa fa-exclamation-circle mr-1" />
          {t('This action cannot be undone.', '이 작업은 되돌릴 수 없습니다.')}
        </p>
      </ConfirmDialog>
    </>
  );
}
